<template>
  <v-card tile height="100%">
    <v-toolbar color="primaryLight" dark dense style="z-index: 2;">
      <v-toolbar-title>Planificación medios terrestres</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-container fluid class="pa-0">
        <!-- Barra superior -->
        <v-row align="center" no-gutters>
          <v-col>
            <v-autocomplete v-model="incendioSelected" :items="incendiosReducedFiltered" label="Incendios"
              :item-text="item => item.NOMBRE ? item.NOMBRE : item.MUNICIPIO" persistent-hint return-object :loading="incendioLoading" :disabled="incendioLoading" />
          </v-col>

          <v-col>
            <v-text-field v-model="fechaIncendio" label="Fecha incendio" readonly />
          </v-col>

          <v-col sm="1">
            <v-text-field v-model="orto" label="Orto" readonly />
          </v-col>

          <v-col sm="1">
            <v-text-field v-model="ocaso" label="Ocaso" readonly />
          </v-col>

          <v-col>
            <v-text-field v-model="fechaActual" label="Fecha/hora actual" readonly />
          </v-col>

          <v-col sm="3">
            <v-autocomplete v-model="filtrosSelected" :items="filtros" label="Filtros" multiple return-object>
              <template #selection="{ item, index }">
                <v-chip small v-if="index === 0">
                  <span>{{ item }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text caption">(+{{ filtrosSelected.length - 1 }} otros)</span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <!-- Tabs -->
        <v-toolbar color="primaryLight" dense style="z-index: 2; position: relative">
          <v-tabs v-model="tabSelected" color="white" background-color="primaryLight" dark slider-color="white">
            <v-tab v-for="t in tabs" :key="t" ripple @click="cambiarTab(t)">
              {{ t }}
            </v-tab>
          </v-tabs>
          <v-tooltip bottom right absolute>
            <template #activator="{ on, attrs }">
              <v-btn fab small v-bind="attrs" v-on="on" color="secondary" bottom right absolute
                @click="guardarPlanificacion()" :disabled="contentSaveDisable" class="bg-color-green mx-15">
                <v-icon color="primary">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Guardar planificación</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn fab small v-bind="attrs" v-on="on" color="secondary" bottom right absolute
                @click="abrirDialogAddMedio()" :disabled="disabledByRol || !incendioSelected || incendioLoading" class="mx-2">
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Añadir medio</span>
          </v-tooltip>
        </v-toolbar>

        <v-tabs-items v-model="tabSelected">
          <v-tab-item key="Tabla" style="height: 60vh; overflow: auto !important;">
            <v-card flat id="tabla">
              <v-card-text>
                <div style="display: inline-flex; align-items: center; width: 100%">
                  <v-btn :disabled="!mediosAsignados || mediosAsignados.length === 0" text icon color="grey"
                    @click="capturaTabla()">
                    <v-icon>mdi-file-pdf-box</v-icon>
                  </v-btn>
                </div>

                <v-data-table :headers="headers" :items="mediosAsignados" single-expand hide-default-footer
                  disable-pagination :loading="incendioLoading">
                  <!--<v-progress-linear
                    v-if="incendioLoading"
                    color="primary"
                    indeterminate
                  />-->
                  <template #no-data>
                    <p>No hay medios asignados.</p>
                  </template>

                  <template #item="{ item }">
                    <tr>
                      <!-- @click="expand(!isExpanded)" -->
                      <td class="text-xs">{{ item.MEDIO }}</td>
                      <td class="text-xs">{{ item.ACTUACION }}</td>
                      <td class="text-xs">{{ item.TIPO }}</td>
                      <td class="text-xs">{{ item.SECTOR.SECTOR }}</td>
                      <td class="text-xs">{{ item.NUM_COMPONENTES }}</td>
                      <td class="text-xs">{{ fechahora(item.INICIO_JORNADA_PLANIF) }}</td>
                      <td class="text-xs">{{ fechahora(item.FECHA_ALARMADO) }}</td>
                      <td class="text-xs">{{ fechahora(item.FECHA_EN_CAMINO) }}</td>
                      <td class="text-xs">{{ fechahora(item.FECHA_EN_LUGAR) }}</td>
                      <td class="text-xs">{{ fechahora(item.FECHA_EN_LUGAR) }}</td>
                      <td class="text-xs">{{ fechahora(item.FECHA_FINALIZADO) }}</td>
                      <td class="text-xs">{{ fechahora(item.FECHA_FINALIZADO) }}</td>
                      <td class="text-xs">{{ fechahora(item.FECHA_FIN_DESCANSO) }}</td>
                      <td class="text-xs-center">
                        <!-- <v-tooltip bottom>
                          <template #activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" :disabled="isAddActuacionDisabled(item)" @click="abrirDialogAddActuacion(item)">
                              <v-icon color="teal">mdi-plus</v-icon>
                            </v-btn>
                          </template>
          <span>Añadir actuación</span>
          </v-tooltip> -->

                        <v-tooltip bottom>
                          <template #activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" :disabled="disabledByRol"
                              @click="abrirDialogEdit(item.ACTUACION > 1, item)">
                              <v-icon color="black">mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template #activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" :disabled="item.TIENE_MAS_ACTUACIONES || disabledByRol"
                              @click="borrarMedioIncendio(item)">
                              <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Eliminar</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item key="Gráfica" eager>
            <v-card flat>
              <v-card-text>
                <div style="display: inline-flex; align-items: center; width: 100%">
                  <v-btn :disabled="!mediosAsignados || mediosAsignados.length === 0" text icon color="grey"
                    @click="capturaGrafica()">
                    <v-icon>mdi-camera-image</v-icon>
                  </v-btn>
                </div>
                <div id="timeline" />
                <!-- LEYENDA PARA EL TIMELINE -->
                <div class="mt-2 legend">
                  <v-row>
                    <v-col cols="auto" class="d-flex align-center">
                      <v-icon small color="#FFC400">mdi-circle</v-icon>
                      <span class="ml-1 caption">Tránsito</span>
                    </v-col>
                    <v-col cols="auto" class="d-flex align-center">
                      <v-icon small color="#FF0000">mdi-circle</v-icon>
                      <span class="ml-1 caption">Incendio</span>
                    </v-col>
                    <v-col cols="auto" class="d-flex align-center">
                      <v-icon small color="#FFFF00">mdi-circle</v-icon>
                      <span class="ml-1 caption">Descanso</span>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </v-card-text>

    <vx-dialog-add-edit-planificacion :show="showDialogAdd" :editedItem="editedItem" :isEdit="isEdit"
      :medios="mediosDisponibles" :sectores="sectores"
      :idIncendioSelected="incendioSelected ? incendioSelected.ID_INCENDIO : null" @cancelar="showDialogAdd = false"
      @aceptar="asignarMedio" @editar="editarAsignacion" />

    <vx-dialog-add-actuacion :show="showDialogActuacion" :editedItem="editedItem" :isEdit="isEdit" :sectores="sectores"
      :periodoAnterior="periodoAnterior" @cancelar="showDialogActuacion = false" @aceptar="asignarMedio"
      @editar="editarAsignacion" />
  </v-card>
</template>

<script>
import { getSunrise, getSunset } from 'sunrise-sunset-js'
import { Timeline, DataSet } from 'vis-timeline/standalone'
import { mapActions, mapGetters } from 'vuex'
import DialogAddActuacionMMTT from './DialogAddActuacionMMTT'
import api from '@/api'
import * as PH from '../../helpers/PlanificacionHelper'
import * as htmlToImage from 'html-to-image'

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import constants from '@/helpers/constants'
import DialogAddEditPlanificacion from './DialogAddEditPlanificacion.vue'
pdfMake.vfs = pdfFonts.vfs

export default {
  name: 'PlanificacionMMTT',

  components: {
    'vx-dialog-add-edit-planificacion': DialogAddEditPlanificacion,
    'vx-dialog-add-actuacion': DialogAddActuacionMMTT
  },

  props: {
    show: Boolean
  },

  data: () => ({
    incendioSelected: null,

    tabs: ['Tabla', 'Gráfica'],
    tabSelected: null,

    timeout: null,
    timer: null,

    showDialogAdd: false,
    showDialogActuacion: false,

    isEdit: false,
    editedItem: {},

    firstTimeFit: false,
    fechaActual: null,

    filtros: [
      // En caso de modificar, ordenar alfabéticamente
      'A. Forestal',
      'Autobomba',
      'Bomba Forestal',
      'Bomba Forestal Ligera',
      'Bomba Forestal Pesada',
      'Bomba Nodriza Pesada',
      'Bomba Rural Ligera',
      'Bomba Rural Pesada',
      'Bomba Urbana Ligera',
      'Bomba Urbana Pesada',
      'Bomberos',
      'Bulldozer',
      'Cuadrilla Helitransportada',
      'Cuña Quitanieves',
      'Equipo Rescate Montaña',
      'Heli Transp. Brigada BRIF',
      'Jefe de Parque',
      'Jefe Perros de Salvamento',
      'Observatorio Forestal',
      'Remolque Electrobomba',
      'Remolque Embarcac. Motor',
      'Retén',
      'Retén Tragsa',
      'SAMU Rescate',
      'Sargento de Guardia: Aralar',
      'Técnico',
      'Vehículo Asistencias Tecnicas',
      'Vehículo Auto Brazo',
      'Vehículo Auto Escalera',
      'Vehículo Mercancías Peligrosas',
      'Vehículo Poli-Brazo/Contenedor',
      'Vehículo Rescate Acuatico',
      'Vehículo Rescate Montaña',
      'Vehículo Rescate Rapido',
      'Vehículo Rescate Taller',
      'Vehículo Servicios',
      'Vehículo Servicios Multiples',
      'Vehículo Transporte Mando',
      'Vehículo Transporte Organos',
      'Vehículo Transporte Perros Sal',
      'Vehículo Transporte Personal'

    ],

    filtrosSelected: [
      // En caso de modificar, ordenar alfabéticamente
      'A. Forestal',
      'Autobomba',
      'Bomba Forestal',
      'Bomba Forestal Ligera',
      'Bomba Forestal Pesada',
      'Bomba Nodriza Pesada',
      'Bomba Rural Ligera',
      'Bomba Rural Pesada',
      'Bomba Urbana Ligera',
      'Bomba Urbana Pesada',
      'Bomberos',
      'Bulldozer',
      'Cuadrilla Helitransportada',
      'Cuña Quitanieves',
      'Equipo Rescate Montaña',
      'Heli Transp. Brigada BRIF',
      'Jefe de Parque',
      'Jefe Perros de Salvamento',
      'Observatorio Forestal',
      'Remolque Embarcac. Motor',
      'Retén',
      'Retén Tragsa',
      'SAMU Rescate',
      'Sargento de Guardia: Aralar',
      'Técnico',
      'Vehículo Asistencias Tecnicas',
      'Vehículo Auto Brazo',
      'Vehículo Auto Escalera',
      'Remolque Electrobomba',
      'Vehículo Mercancías Peligrosas',
      'Vehículo Poli-Brazo/Contenedor',
      'Vehículo Rescate Acuatico',
      'Vehículo Rescate Montaña',
      'Vehículo Rescate Rapido',
      'Vehículo Rescate Taller',
      'Vehículo Servicios',
      'Vehículo Servicios Multiples',
      'Vehículo Transporte Organos',
      'Vehículo Transporte Mando',
      'Vehículo Transporte Perros Sal',
      'Vehículo Transporte Personal'
    ],

    headers: [
      { text: 'Medio', value: 'MEDIO', align: 'left' },
      { text: 'Actuación', value: 'ACTUACION', align: 'left', sortable: false },
      { text: 'Tipo', value: 'TIPO', align: 'left' },
      { text: 'Sector', value: 'SECTOR.SECTOR', align: 'left' },
      { text: 'Nº componentes', value: 'NUM_COMPONENTES', align: 'left' },
      { text: 'Inicio de jornada', value: 'INICIO_JORNADA', align: 'left' },
      { text: 'Incorporación al incendio', value: 'FECHA_INCORPORACION', align: 'left' },
      { text: 'Movilización a incendio', value: 'FECHA_ALARMADO', align: 'left' },
      { text: 'Llegada a incendio', value: 'FECHA_EN_CAMINO', align: 'left' },
      { text: 'Fecha salida incendio', value: 'FECHA_EN_LUGAR', align: 'left' },
      { text: 'Fecha máxima de actuación', value: 'FECHA_MAX_ACTUACION', align: 'left' },
      { text: 'Llegada base', value: 'FECHA_FINALIZADO', align: 'left' },
      { text: 'Fin descanso', value: 'FECHA_FIN_DESCANSO', align: 'left' },
      { text: 'Acciones', value: 'name', sortable: false, align: 'center', width: '8%' }
    ],

    mediosDisponibles: [],

    mediosAsignados: [],

    periodoAnterior: {},

    numDiasPasado: 3,
    numDiasFuturo: 3,

    isLoading: false,
    contentSaveDisable: true,
    mediosPlanificados: [],

    lastIncFetchId: null,
    incendioLoading: false
  }),

  computed: {
    ...mapGetters('medio', [
      'tiposMedio', 'medios'
    ]),
    ...mapGetters('incendio', [
      'incendiosReducedFiltered', 'isIncendioFinalizado'
    ]),
    incendiosActivos() {
      const lista = Array.isArray(this.incendiosReducedFiltered) ? this.incendiosReducedFiltered : []
      return lista.filter(inc => !this.isIncendioFinalizado(inc.ID_INCENDIO))
    },

    sectores() {
      let sectores = []

      if (this.incendioSelected && this.incendioSelected.SECTORES) {
        this.incendioSelected.SECTORES.forEach((s) => {
          sectores.push({ ID_SECTOR: s.ID_SECTOR, SECTOR: s.SECTOR })
        })
        sectores.sort((x, y) => {
          return x.SECTOR === 'GENERAL' ? -1 : y.SECTOR === 'GENERAL' ? 1 : 0
        })
      }

      return sectores
    },

    mediosItems() {
      const mediosCopy = JSON.parse(JSON.stringify(this.medios))
      let mediosFiltered = mediosCopy.filter(x => x.CATEGORIA !== 'Aéreo').sort((a, b) => {
        return a.MEDIO - b.MEDIO
      })
      return mediosFiltered
    },

    fechaIncendio() {
      let fecha = null
      if (this.incendioSelected && this.incendioSelected.FECHA_CREACION) {
        fecha = this.$date.formatDate(this.incendioSelected.FECHA_CREACION, 'DD/MM/YYYY HH:mm')
      }

      return fecha
    },

    orto() {
      let orto = null
      if (this.incendioSelected && this.incendioSelected.LATITUD) {
        let sunrise = getSunrise(this.incendioSelected.LATITUD, this.incendioSelected.LONGITUD, new Date(this.incendioSelected.FECHA_CREACION))
        orto = this.$date.formatDate(sunrise.toISOString(), 'HH:mm')
      }

      return orto
    },

    ocaso() {
      let ocaso = null
      if (this.incendioSelected && this.incendioSelected.LATITUD) {
        let sunset = getSunset(this.incendioSelected.LATITUD, this.incendioSelected.LONGITUD, new Date(this.incendioSelected.FECHA_CREACION))
        ocaso = this.$date.formatDate(sunset.toISOString(), 'HH:mm')
      }

      return ocaso
    },
    disabledByRol() {
      // Deshabilita funciones dependiendo del rol
      return !this.$store.getters['usuario/isCurrentUsuarioAdmin']
    }
  },

  watch: {
    incendiosReducedFiltered: {
      immediate: true,
      async handler(incendios) {
        if (!this.incendioSelected && incendios.length) {
          const first = incendios[0]
          this.incendioSelected = first
          this.lastIncFetchId = first.ID_INCENDIO
          this.incendioLoading = true
          try {
            const incendio = await this.fetchIncendioById(first.ID_INCENDIO)
            if (incendio && this.lastIncFetchId === incendio.ID_INCENDIO) {
              this.incendioSelected = incendio
              this.getMediosAsignadosIncendio()
              this.actualizarDatos()
            }
          } catch (err) {
            this.$log.error(err)
            this.$notify({ title: 'Error', text: 'No se pudo obtener el incendio.', type: 'error' })
          } finally {
            this.incendioLoading = false
          }
        }
      }
    },

    incendiosActivos(val) {
      let is = this.incendioSelected ? this.incendiosActivos.find(x => x.ID_INCENDIO === this.incendioSelected.ID_INCENDIO) : null

      if (this.incendiosActivos.length > 0 && !this.incendioSelected) {
        this.incendioSelected = this.incendiosActivos[0]
        this.oldIncendioActivo = this.incendiosActivos
      }

      if (JSON.stringify(val) === JSON.stringify(this.oldIncendioActivo)) return

      if (this.incendioSelected) { // HACK: el refresher modifica los incendios y luego el watch de 'incendioSelected.SECTORES' no funciona
        is = this.incendiosActivos.find(x => x.ID_INCENDIO === this.incendioSelected.ID_INCENDIO)
        this.incendioSelected = is
        this.oldIncendioActivo = this.incendiosActivos
      }
    },

    mediosItems(val, oldVal) { // Necesario para carga inicial al refrescar la web en esta ruta
      if (oldVal.length === 0) {
        this.getMediosAsignadosIncendio()
        this.actualizarDatos()
      }
    },

    async incendioSelected(val) {
      if (!val) return
      if (!this.timeline) this.initTimeline()
      if (!val.SECTORES) {
        this.lastIncFetchId = val.ID_INCENDIO
        this.incendioLoading = true
        try {
          const inc = await this.fetchIncendioById(val.ID_INCENDIO)
          if (inc && this.lastIncFetchId === inc.ID_INCENDIO) {
            this.incendioSelected = inc
            this.getMediosAsignadosIncendio()
            this.actualizarDatos()
          }
        } catch (err) {
          this.$log.error(err)
          this.$notify({ title: 'Error', text: 'No se pudo obtener el incendio.', type: 'error' })
        } finally {
          this.incendioLoading = false
        }
      } else {
        this.getMediosAsignadosIncendio()
        this.actualizarDatos()
      }
    },

    'incendioSelected.SECTORES': {
      handler() {
        if (!this.incendioSelected) return
        this.getMediosAsignadosIncendio()
        this.actualizarDatos()
      },
      deep: true
    },

    filtrosSelected() {
      this.filtrarDatos()
    }
  },

  beforeDestroy() {
    this.timeline = null
    clearTimeout(this.timeout)
    clearInterval(this.timer)
  },

  mounted() {
    this.init()
  },

  methods: {
    ...mapActions('incendio', ['addMediosIncendio', 'editMedioIncendio', 'editPlanificacionMedio', 'deleteMedioIncendio', 'fetchIncendioById']),
    async init() {
      this.fechaActual = this.$date.currentDate()

      // Seleccionar primer incendio
      // if (this.incendiosActivos.length > 0) {
      //   this.incendioSelected = this.incendiosActivos[0]
      // }

      // this.initTimeline()

      // El timeout hace que salte exactamente en el segundo 00
      let secondsLeft = 60 - new Date().getSeconds()
      this.timeout = setTimeout(() => {
        this.fechaActual = this.$date.currentDate()

        // No se para que sirve
        this.timer = setInterval(() => {
          this.fechaActual = this.$date.currentDate()
          if (this.timeline) {
            this.getMediosAsignadosIncendio()
            this.actualizarDatos()
          }
        }, 1 * 10000)
      }, secondsLeft * 1000)
    },

    capturaTabla() { // TODO:
      let bodyPdf = []
      bodyPdf.push(['Medio', 'Actuación', 'Tipo', 'Sector', 'Nº comp.', 'Inicio de jornada', 'Incorp. incendio', 'Movil. incendio', 'Llegada a incendio', 'Fecha máxima de actuación', 'Llegada base', 'Fin descanso'])
      for (let i = 0; i < this.mediosAsignados.length; i++) {
        let medio = this.mediosAsignados[i]

        let datosMedio = []
        datosMedio.push({ text: medio.MEDIO, bold: true })
        datosMedio.push(medio.ACTUACION)
        datosMedio.push(medio.TIPO)
        datosMedio.push(medio.SECTOR.SECTOR)
        datosMedio.push(medio.NUM_COMPONENTES)
        datosMedio.push(this.$date.parseDate(medio.INICIO_JORNADA_PLANIF).format('DD/MM/YYYY HH:mm'))
        datosMedio.push(this.$date.parseDate(medio.FECHA_INCORPORACION).format('DD/MM/YYYY HH:mm'))
        datosMedio.push(this.$date.parseDate(medio.FECHA_ALARMADO).format('DD/MM/YYYY HH:mm'))
        datosMedio.push(this.$date.parseDate(medio.FECHA_EN_CAMINO).format('DD/MM/YYYY HH:mm'))
        datosMedio.push(this.$date.parseDate(medio.FECHA_MAX_ACTUACION).format('DD/MM/YYYY HH:mm'))
        datosMedio.push(this.$date.parseDate(medio.FECHA_FINALIZADO).format('DD/MM/YYYY HH:mm'))
        datosMedio.push(this.$date.parseDate(medio.FECHA_FIN_DESCANSO).format('DD/MM/YYYY HH:mm'))
        bodyPdf.push(datosMedio)
      }

      const docDefinition = {
        pageOrientation: 'landscape',
        content: [

        ],
        defaultStyle: {
          fontSize: 9
        }
      }
      docDefinition.content.push(constants.headerPDF)
      docDefinition.content.push(

        {
          text: [{ text: 'Incendio: ', bold: true }, this.incendioSelected.MUNICIPIO, { text: '  |  Fecha/hora inicio: ', bold: true }, this.$date.parseDate(this.incendioSelected.FECHA_CREACION).format('DD/MM/YYYY HH:mm'),
            { text: '  |  Orto: ', bold: true }, this.orto, { text: '  |  Ocaso: ', bold: true }, this.ocaso,
            { text: '  |  Fecha/hora informe: ', bold: true }, this.fechaActual],
          margin: [0, 0, 0, 15]
        },
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 1,
            body: bodyPdf
          },
          margin: [0, 15, 0, 20]
        }
      )
      pdfMake.createPdf(docDefinition).download(`MMTT_Tiempos_${this.incendioSelected.MUNICIPIO}_${this.$date.now().format('YYYY_MM_DD_hh_mm')}`)
    },

    async capturaGrafica() { // TODO:
      try {
        let dataUrl = await htmlToImage.toJpeg(document.getElementById('timeline'), { quality: 0.95 })

        let link = document.createElement('a')
        link.download = `MMTT_${this.incendioSelected.MUNICIPIO}_${this.$date.now().format('YYYY_MM_DD_hh_mm')}.jpeg`
        link.href = dataUrl
        link.click()
      } catch (err) {
        this.$log.error(err)
        this.$notify({ title: 'Error', text: 'No se pudo realizar la captura, intente recargar la página', type: 'error' })
      }
    },

    isAddActuacionDisabled(medio) {
      return !medio.FECHA_FINALIZADO || medio.FECHA_FINALIZADO >= this.$date.now() || medio.TIENE_MAS_ACTUACIONES || medio.MAX_ACTUACIONES
    },

    cambiarTab(tab) {
      setInterval(() => {
        this.getMediosAsignadosIncendio()
        this.actualizarDatos()
        if (this.timeline) this.timeline.redraw()
      }, 20000)
    },

    getMediosDisponibles() {
      return this.mediosItems.filter(x => x.ESTADO === constants.estadosMedio[3].ID).sort((a, b) => a.MEDIO.localeCompare(b.MEDIO))
    },

    actualizarDatos() { // Actualiza los datos que se muestran en la timeline objetivo
      this.mediosDisponibles = this.getMediosDisponibles()

      this.updateTimeLine()
      this.filtrarDatos()
    },

    getMediosAsignadosIncendio() { // Lista los medios asignados al incendio
      this.mediosAsignados = []

      let mediosIncendio = this.getMediosIncendio()

      for (let i = 0; i < mediosIncendio.length; i++) {
        let p = mediosIncendio[i]

        const SECTOR = p.sector
        const MEDIO = p.medio

        let medio = this.mediosItems.find(x => x.ID_MEDIO === MEDIO.ID_MEDIO)

        if (medio) {
          const FECHA_ALARMADO = MEDIO.FECHA_ALARMADO ? MEDIO.FECHA_ALARMADO : null
          const FECHA_EN_CAMINO = MEDIO.FECHA_EN_CAMINO ? MEDIO.FECHA_EN_CAMINO : null
          const FECHA_EN_LUGAR = MEDIO.FECHA_EN_LUGAR ? MEDIO.FECHA_EN_LUGAR : null
          const FECHA_FINALIZADO = MEDIO.FECHA_FINALIZADO ? MEDIO.FECHA_FINALIZADO : null
          const FECHA_FIN_DESCANSO = MEDIO.FECHA_FIN_DESCANSO ? MEDIO.FECHA_FIN_DESCANSO : null

          // PRIORIDAD PARA ORDENER LA TABLA
          if (MEDIO.PLANIFICACION) {
            MEDIO.PLANIFICACION.PRIORIDAD = i
          }

          let data = {
            ID_MEDIO: medio.ID_MEDIO,
            ID_MEDIO_SECTOR: MEDIO.ID_MEDIO_SECTOR,
            MEDIO: medio.MEDIO,
            TIPO: medio.TIPO,
            SECTOR,
            NUM_COMPONENTES: MEDIO.NUM_COMPONENTES,
            HORA_ENTRADA: medio.HORA_ENTRADA,
            HORA_SALIDA: medio.HORA_SALIDA,
            FECHA_ALARMADO,
            FECHA_EN_CAMINO,
            FECHA_EN_LUGAR,
            FECHA_FINALIZADO,
            FECHA_FIN_DESCANSO,
            PLANIFICACION: MEDIO.PLANIFICACION
          }
          this.calcularActuacion(data)
        }
      }
    },

    calcularActuacion(medio) { // Calcula los tiempos de actuacion del medio usando los datos disponibles
      let planificacion = medio.PLANIFICACION
      if (!planificacion) return

      let actuacion = this.getNumeroActuaciones(medio.ID_MEDIO)

      const FECHA_ALARMADO = medio.FECHA_ALARMADO ? this.$date.parseDate(medio.FECHA_ALARMADO) : this.$date.parseDate(planificacion.FECHA_ALARMADO_PLANIF)
      const FECHA_EN_CAMINO = medio.FECHA_EN_CAMINO ? this.$date.parseDate(medio.FECHA_EN_CAMINO) : this.$date.parseDate(planificacion.FECHA_EN_CAMINO_PLANIF)
      const FECHA_EN_LUGAR = medio.FECHA_EN_LUGAR ? this.$date.parseDate(medio.FECHA_EN_LUGAR) : this.$date.parseDate(planificacion.FECHA_EN_LUGAR_PLANIF)
      const FECHA_FINALIZADO = medio.FECHA_FINALIZADO ? this.$date.parseDate(medio.FECHA_FINALIZADO) : this.$date.parseDate(planificacion.FECHA_FINALIZADO_PLANIF)
      const FECHA_FIN_DESCANSO = medio.FECHA_FIN_DESCANSO ? this.$date.parseDate(medio.FECHA_FIN_DESCANSO) : this.$date.parseDate(planificacion.FECHA_FIN_DESCANSO_PLANIF)

      const INICIO_JORNADA = FECHA_ALARMADO < this.$date.parseDate(planificacion.INICIO_JORNADA)
        ? FECHA_ALARMADO
        : this.$date.parseDate(planificacion.INICIO_JORNADA)
          ? this.$date.parseDate(planificacion.INICIO_JORNADA)
          : this.$date.parseDate(this.orto)

      // PRIORIDAD PARA ORDENAR LA TABLA
      const PRIORIDAD = planificacion.PRIORIDAD ?? 0

      // Desactivar botones si tiene mas actuaciones
      if (actuacion > 0) {
        for (let i = 0; i < this.mediosAsignados.length; i++) {
          let m = this.mediosAsignados[i]
          if (m.ID_MEDIO === medio.ID_MEDIO && m.ACTUACION === actuacion) {
            m.TIENE_MAS_ACTUACIONES = true
          }
        }
      }

      let data = {
        ID_MEDIO: medio.ID_MEDIO, // Para desplegar la tabla requiere tener un campo 'id'
        MEDIO: medio.MEDIO,
        ID_MEDIO_SECTOR: medio.ID_MEDIO_SECTOR,
        ACTUACION: actuacion + 1,
        TIPO: medio.TIPO,
        SECTOR: medio.SECTOR,
        NUM_COMPONENTES: medio.NUM_COMPONENTES,
        INICIO_JORNADA: medio.HORA_ENTRADA,
        FIN_JORNADA: medio.HORA_SALIDA,
        INICIO_JORNADA_PLANIF: INICIO_JORNADA,
        TIEMPO_DESCANSO: planificacion.TIEMPO_DESCANSO,
        TIEMPO_OPERATIVO: planificacion.TIEMPO_OPERATIVO,
        FECHA_ALARMADO,
        FECHA_EN_CAMINO,
        FECHA_EN_LUGAR,
        FECHA_FINALIZADO,
        FECHA_FIN_DESCANSO,
        PRIORIDAD
      }

      this.mediosAsignados.push(data)
    },

    filtrarDatos() { // Filtra los grupos de planificacion
      let ids = []
      if (this.filtrosSelected.includes('Retén')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Retén').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Retén Tragsa')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Retén Tragsa').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Cuadrilla Helitransportada')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Cuadrilla Helitransportada').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('A. Forestal')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Agente Forestal').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Técnico')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO.includes('Técnico')).map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Autobomba')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Autobomba').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Bulldozer')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Bulldozer').map(t => t.ID_MEDIO))
      }

      // Nuevos tipos de medio
      // Terrestres
      if (this.filtrosSelected.includes('Vehículo Auto Escalera')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Auto Escalera').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Rescate Acuatico')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Rescate Acuatico').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Equipo Rescate Montaña')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Equipo Rescate Montaña').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Bomba Urbana Pesada')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Bomba Urbana Pesada').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Rescate Rapido')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Rescate Rapido').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Bomba Forestal Ligera')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Bomba Forestal Ligera').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Remolque Electrobomba')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Remolque Electrobomba').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Bomba Urbana Ligera')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Bomba Urbana Ligera').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Bomba Rural Ligera')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Bomba Rural Ligera').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Transporte Organos')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Transporte Organos').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Bomba Forestal Pesada')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Bomba Forestal Pesada').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Transporte Mando')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Transporte Mando').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Poli-Brazo/Contenedor')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Poli-Brazo/Contenedor').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Bomba Forestal')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Bomba Forestal').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Cuña Quitanieves')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Cuña Quitanieves').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Servicios')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Servicios').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Bomba Rural Pesada')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Bomba Rural Pesada').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Rescate Montaña')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Rescate Montaña').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Auto Brazo')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Auto Brazo').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Rescate Taller')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Rescate Taller').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Mercancías Peligrosas')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Mercancías Peligrosas').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Asistencias Tecnicas')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Asistencias Tecnicas').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Remolque Embarcac. Motor')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Remolque Embarcac. Motor').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Transporte Personal')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Transporte Personal').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Transporte Perros Sal')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Transporte Perros Sal').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Bomberos')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Bomberos').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Vehículo Servicios Multiples')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Vehículo Servicios Multiples').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Bomba Nodriza Pesada')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Bomba Nodriza Pesada').map(t => t.ID_MEDIO))
      }

      // Recursos
      if (this.filtrosSelected.includes('Heli Transp. Brigada BRIF')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Heli Transp. Brigada BRIF').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Jefe de Parque')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Jefe de Parque').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('SAMU Rescate')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'SAMU Rescate').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Jefe Perros de Salvamento')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Jefe Perros de Salvamento').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Observatorio Forestal')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Observatorio Forestal').map(t => t.ID_MEDIO))
      }
      if (this.filtrosSelected.includes('Sargento de Guardia: Aralar')) {
        ids = ids.concat(this.mediosAsignados.filter(t => t.TIPO === 'Sargento de Guardia: Aralar').map(t => t.ID_MEDIO))
      }

      // this.mediosAsignados.forEach((m) => {
      //   if (ids.includes(m.ID_MEDIO)) {
      //     m.hide = false
      //   } else m.hide = true
      // })

      // Ocultar los grupos que no se deben ver: vacios, que no cumplen el filtro
      if (this.timeline && this.timeline.groupsData) {
        this.timeline.groupsData._data.forEach((group) => {
          if (ids.includes(group.id)) {
            this.timeline.groupsData._data.update({ id: group.id, visible: true })
          } else this.timeline.groupsData._data.update({ id: group.id, visible: false })
        })
      }
    },

    getMediosIncendio() { // Devuelve la lista de los medios en cada sector
      let listaMediosIncendio = []

      if (!this.incendioSelected || !Array.isArray(this.incendioSelected.SECTORES)) {
        return listaMediosIncendio
      }
      for (let i = 0; i < this.incendioSelected.SECTORES.length; i++) {
        let s = this.incendioSelected.SECTORES[i]

        for (let j = 0; j < s.MEDIOS.length; j++) {
          let m = s.MEDIOS[j]

          listaMediosIncendio.push({ // TODO: mayuscula // TODO: en sector no está la lista de medios???
            sector: JSON.parse(JSON.stringify(s)),
            medio: JSON.parse(JSON.stringify(m))
          })
        }
        listaMediosIncendio = listaMediosIncendio.filter(MEDIO => MEDIO.medio.PLANIFICACION !== null)

        if (listaMediosIncendio.length === 0) return listaMediosIncendio

        listaMediosIncendio = listaMediosIncendio.sort((a, b) => { // Ordenar por fecha aviso para numerar actuaciones
          let fechaA = a.medio.PLANIFICACION.PRIORIDAD ?? this.$date.parseDate(a.medio.PLANIFICACION.FECHA_AVISO_PLANIF).valueOf()
          let fechaB = b.medio.PLANIFICACION.PRIORIDAD ?? this.$date.parseDate(b.medio.PLANIFICACION.FECHA_AVISO_PLANIF).valueOf()
          return fechaA - fechaB
        })
      }
      return listaMediosIncendio
    },

    getNumeroActuaciones(idMedio) { // Devuelve el numero de actuaciones de un medio concreto
      return this.mediosAsignados.filter(x => x.ID_MEDIO === idMedio).length
    },

    // #region Dialogs Add/Edit Medio y Actuacion
    abrirDialogAddMedio() { // Muestra el panel de añadir un medio a la timeline
      this.showDialogAdd = true

      this.isEdit = false
      this.editedItem = {}
    },

    async asignarMedio(data) { // Añade el medio a la lista y al incendio
      this.showDialogAdd = false

      try {
        // Add medio al incendio
        let mediosIncendio = {
          ID_INCENDIO: this.incendioSelected.ID_INCENDIO,
          ID_SECTOR: data.SECTOR.ID_SECTOR,
          MEDIOS: []
        }

        let idMedioSector = this.$uuid.createUUID()
        let planificacion = {
          ID_PLANIFICACION_MEDIO: this.$uuid.createUUID(),
          ID_MEDIO_SECTOR: idMedioSector,
          INICIO_JORNADA: data.INICIO_JORNADA,
          TIEMPO_OPERATIVO: data.TIEMPO_OPERATIVO,
          TIEMPO_DESCANSO: data.TIEMPO_DESCANSO,
          FECHA_ALARMADO_PLANIF: data.HORA_MOVILIZACION,
          FECHA_EN_CAMINO_PLANIF: data.HORA_LLEGADA_INC,
          FECHA_EN_LUGAR_PLANIF: data.FECHA_SALIDA_INC,
          FECHA_FINALIZADO_PLANIF: data.FECHA_LLEGADA_BASE,
          FECHA_FIN_DESCANSO_PLANIF: data.FECHA_FIN_DESCANSO,
          PRIORIDAD: data.PRIORIDAD
        }

        let medioSector = {
          ID_MEDIO_SECTOR: idMedioSector,
          ID_SECTOR: data.SECTOR.ID_SECTOR,
          ID_MEDIO: data.ID_MEDIO,
          FECHA_ALARMADO: null,
          FECHA_EN_CAMINO: null,
          FECHA_EN_LUGAR: null,
          FECHA_FINALIZADO: null,
          FECHA_FIN_DESCANSO: null,
          FECHA_AVISO_PLANIF: null,
          FECHA_LLEGADA_PLANIF: null,
          NUM_COMPONENTES: data.NUM_COMPONENTES,
          PLANIFICACION: planificacion
        }

        // Comprobar si es a futuro o real
        const currentTime = this.$date.now()
        medioSector = PH.comprobarFechas(medioSector, currentTime)

        mediosIncendio.MEDIOS.push(medioSector)
        this.addMediosIncendio(mediosIncendio)
      } catch (err) {
        this.$log.error(err)
        this.$notify({ title: 'Error', text: 'No se pudo asignar el medio, intente recargar la página', type: 'error' })
      }
    },

    async editarAsignacion(data) {
      this.showDialogAdd = false
      this.showDialogActuacion = false

      for (let i = 0; i < this.mediosAsignados.length; i++) {
        if (
          this.mediosAsignados[i].ID_MEDIO === data.ID_MEDIO &&
          this.mediosAsignados[i].ACTUACION === data.ACTUACION
        ) {
          const oldSector = this.mediosAsignados[i].SECTOR.ID_SECTOR

          const originalMedio = this.incendioSelected.SECTORES
            .find(x => x.ID_SECTOR === oldSector)
            .MEDIOS.find(x => x.ID_MEDIO === data.ID_MEDIO)

          // CLONAR EL MEDIO_SECTOR PARA NO MUTARLO DIRECTAMENTE
          let medioSector = JSON.parse(JSON.stringify(originalMedio))

          medioSector.FECHA_ALARMADO = null
          medioSector.FECHA_EN_CAMINO = null
          medioSector.FECHA_EN_LUGAR = null
          medioSector.FECHA_AVISO_PLANIF = null
          medioSector.FECHA_LLEGADA_PLANIF = null
          medioSector.FECHA_FINALIZADO = null
          medioSector.FECHA_FIN_DESCANSO = null
          medioSector.NUM_COMPONENTES = data.NUM_COMPONENTES
          medioSector.ID_SECTOR = data.SECTOR.ID_SECTOR
          medioSector.ID_INCENDIO = this.incendioSelected.ID_INCENDIO

          // Comprobar si es a futuro o real
          const currentTime = this.$date.now()
          medioSector = PH.comprobarFechas(medioSector, currentTime)

          this.editMedioIncendio(medioSector)

          // CLONAMOS TAMBIÉN LA PLANIFICACION PARA NO MUTAR EL ESTADO
          let newPlanif = JSON.parse(JSON.stringify(medioSector.PLANIFICACION))

          newPlanif.INICIO_JORNADA = data.INICIO_JORNADA
          newPlanif.TIEMPO_OPERATIVO = data.TIEMPO_OPERATIVO
          newPlanif.TIEMPO_DESCANSO = data.TIEMPO_DESCANSO
          newPlanif.FECHA_ALARMADO_PLANIF = data.HORA_MOVILIZACION
          newPlanif.FECHA_EN_CAMINO_PLANIF = data.HORA_LLEGADA_INC
          newPlanif.FECHA_EN_LUGAR_PLANIF = data.FECHA_SALIDA_INC
          newPlanif.FECHA_FINALIZADO_PLANIF = data.FECHA_LLEGADA_BASE
          newPlanif.FECHA_FIN_DESCANSO_PLANIF = data.FECHA_FIN_DESCANSO
          newPlanif.PRIORIDAD = data.PRIORIDAD
          let planificacion = {
            ID_INCENDIO: this.incendioSelected.ID_INCENDIO,
            PLANIFICACION: newPlanif
          }
          await this.editPlanificacionMedio(planificacion)
        }
      }
    },

    abrirDialogAddActuacion(data) {
      this.periodoAnterior = data
      this.showDialogActuacion = true

      this.isEdit = false
      this.editedItem = {}
    },

    abrirDialogEdit(isActuacion, item) { // Muestra el panel de edicion de medio / actuacion
      this.isEdit = true
      this.editedItem = Object.assign({}, item)

      if (isActuacion) {
        this.showDialogActuacion = true
        this.periodoAnterior = item
      } else {
        this.showDialogAdd = true
      }
    },

    borrarMedioIncendio(data) { // Elimina el medio
      this.$root.$confirmDialog.open('¿Está seguro?', 'Eliminando actuación').then(result => {
        if (result) {
          let idMedioSector = data.ID_MEDIO_SECTOR

          this.mediosItems.find(x => x.ID_MEDIO === data.ID_MEDIO).ESTADO = constants.estadosMedio[3].ID

          this.mediosDisponibles = this.mediosItems.filter(x => x.ESTADO === constants.estadosMedio[3].ID)

          let medioDelete = {
            ID_INCENDIO: this.incendioSelected.ID_INCENDIO,
            ID_MEDIO: data.ID_MEDIO,
            ID_SECTOR: data.SECTOR.ID_SECTOR,
            ID_MEDIO_SECTOR: idMedioSector
          }
          this.deleteMedioIncendio(medioDelete)
        }
      })
    },

    optionsTimeLine() {
      let orto = getSunrise(this.incendioSelected.LATITUD, this.incendioSelected.LONGITUD, new Date())
      let ocaso = getSunset(this.incendioSelected.LATITUD, this.incendioSelected.LONGITUD, new Date())

      let minTimeLine = this.$date.parseDate(orto).subtract(this.numDiasPasado, 'days')
      let maxTimeLine = this.$date.parseDate(ocaso).add(this.numDiasFuturo, 'days')

      let initTimeLine = minTimeLine // this.$date.now().subtract(1, 'days')
      let endTimeLine = this.$date.now().add(12, 'hours')

      let options = {
        groupEditable: {
          order: true
        },
        groupOrder: (a, b) => {
          return a.order - b.order
        },
        groupOrderSwap: (fromGroup, toGroup, groupsDataSet) => { // TODO: GUARDAR EN LA BASE DE DATOS PARA QUE SE MANTENGA EL ORDER
          const fromOrder = fromGroup.order
          fromGroup.order = toGroup.order
          toGroup.order = fromOrder
          groupsDataSet.update([fromGroup, toGroup])
          this.sincronizarTimeLine(fromGroup.id, fromGroup.order)
          this.sincronizarTimeLine(toGroup.id, toGroup.order)
        },

        stack: false,
        showTooltips: true,
        tooltip: {
          followMouse: true,
          overflowMethod: 'cap'
        },
        orientation: 'top',
        zoomMin: 100000,
        maxHeight: 'calc(70vh - 100px)',
        verticalScroll: true,
        zoomKey: 'ctrlKey',
        min: minTimeLine.valueOf(),
        max: maxTimeLine.valueOf(),
        start: initTimeLine.valueOf(),
        end: endTimeLine.valueOf(),
        editable: {
          add: false,
          remove: false,
          updateTime: true,
          updateGroup: false,
          overrideItems: true
        }

      }
      return options
    },

    initTimeline() { // Inicializa las timelines
      if (!this.timeline) {
        this.$nextTick(() => {
          let container = document.getElementById('timeline')
          if (!container) {
            return
          }
          this.timeline = new Timeline(container)
          this.timeline.setOptions(this.optionsTimeLine())
          this.timeline.on('changed', this.sincronizarTimeLine)
        })
      }
    },

    sincronizarTimeLine(idGroup, orderGroup) {
      // Obtener items de la timeline
      const itemsArray = Object.values(this.timeline.itemSet?.items ?? {})

      // Determinar el grupo seleccionado
      let ID_GROUP = idGroup
      if (!ID_GROUP) {
        const itemSelected = itemsArray.find(item => item.selected)
        if (!itemSelected) return // Salir si no hay item seleccionado
        ID_GROUP = itemSelected.data.group
      }

      // Filtrar y ordenar los items por grupo
      const itemsByGroup = itemsArray
        .filter(item => item.data.group === ID_GROUP)
        .sort((a, b) => a.data.start - b.data.start)

      // Obtener la prioridad según el orden del grupo
      const PRIORIDAD = orderGroup ?? this.timeline.itemSet?.groupIds?.findIndex(groupId => groupId === ID_GROUP) ?? -1

      for (let i = 0; i < itemsByGroup.length; i++) {
        let item = itemsByGroup[i]
        if (i > 0) {
          itemsByGroup[i - 1].data.end = item.data.start
        }
      }
      // Primero se obtienen los medios del incendio
      let mediosIncendio = this.getMediosIncendio()
      // Se obtiene el medio seleccionado mediante la id del grupo del timeline
      let medioSelected = mediosIncendio.find(medio => medio.medio.ID_MEDIO === ID_GROUP)
      const SECTOR = medioSelected.sector
      const MEDIO = medioSelected.medio
      let medio = this.mediosItems.find(m => m.ID_MEDIO === MEDIO.ID_MEDIO)

      const fechaAvisoPlanif = this.$date.parseDate(itemsByGroup[0].data.start)
      const fechaLlegadaPlanif = this.$date.parseDate(itemsByGroup[0].data.end)
      let esFechaDeAvisoAntes = new Date(medioSelected.medio.PLANIFICACION.INICIO_JORNADA).getTime() > new Date(fechaAvisoPlanif).getTime()
      let fechaInicioJornada = esFechaDeAvisoAntes ? fechaAvisoPlanif : this.$date.parseDate(medioSelected.medio.PLANIFICACION.INICIO_JORNADA)
      const fechaLlegadaBase = this.$date.parseDate(itemsByGroup[2].data.end)
      const salidaInc = this.$date.parseDate(itemsByGroup[1].data.end)
      const tiempoOperativo = new Date(fechaLlegadaBase).getTime() - new Date(fechaInicioJornada).getTime()
      const tiempoOperativoEnHoras = Math.floor(tiempoOperativo / (1000 * 60 * 60))
      const tiempoDescanso = new Date(itemsByGroup[3].data.end).getTime() - new Date(itemsByGroup[3].data.start).getTime()
      const tiempoDescansoEnHoras = Math.floor(tiempoDescanso / (1000 * 60 * 60))
      const fechaFinDescanso = this.$date.parseDate(itemsByGroup[3].data.end)

      /// //////// ADAPTAR LOS DATOS PARA LAS ACTUALIZACIONES ///////////
      const medioUpdate = {
        ACTUACION: 1,
        FECHA_FIN_DESCANSO: fechaFinDescanso,
        FECHA_INCORPORACION: fechaInicioJornada,
        FECHA_LLEGADA_BASE: fechaLlegadaBase,
        FECHA_MAX_ACTUACION: fechaLlegadaBase,
        FECHA_SALIDA_INC: salidaInc,
        HORA_LLEGADA_INC: fechaLlegadaPlanif,
        HORA_MOVILIZACION: fechaAvisoPlanif,
        ID_MEDIO: medio.ID_MEDIO,
        INICIO_JORNADA: fechaInicioJornada,
        MEDIO: medio.MEDIO,
        NUM_COMPONENTES: MEDIO.NUM_COMPONENTES,
        SECTOR: {
          ID_SECTOR: SECTOR.ID_SECTOR,
          SECTOR: SECTOR.SECTOR
        },
        TIEMPO_DESCANSO: tiempoDescansoEnHoras,
        TIEMPO_OPERATIVO: tiempoOperativoEnHoras,
        TIPO: medio.TIPO,
        PRIORIDAD
      }

      const index = this.mediosPlanificados.findIndex(x => x.ID_MEDIO === medioUpdate.ID_MEDIO)
      if (index !== -1) {
        this.mediosPlanificados[index] = medioUpdate
      } else {
        this.mediosPlanificados.push(medioUpdate)
      }
      this.contentSaveDisable = false
    },

    guardarPlanificacion() {
      this.mediosPlanificados.forEach(medioNuevo => {
        medioNuevo.ID_INCENDIO = this.incendioSelected.ID_INCENDIO
        this.editarAsignacion(medioNuevo)
      })

      this.contentSaveDisable = true
    },

    updateTimeLine() { // Actualiza la timeline
      if (this.timeline) {
        // this.timeline.setOptions(this.optionsTimeLine())
        this.setGroups(this.timeline)
        this.setItems(this.timeline)
      }
    },

    setGroups(timeline) { // Crear los grupos de la timeline y los asigna
      let groups = []

      for (let i = 0; i < this.mediosAsignados.length; i++) {
        let t = this.mediosAsignados[i]

        // Crear cada grupo (medio)
        let initTime = null // Tiempo inicial, para ordenar
        if (t.FECHA_INCORPORACION) {
          initTime = this.$date.parseDate(t.FECHA_ALARMADO)
        }

        // Controlar si ya esta asignado a otro incendio
        if (!groups.find(x => x.id === t.ID_MEDIO)) {
          groups.push({
            id: t.ID_MEDIO,
            content: `<span align="left">${t.MEDIO}</span>`,
            initTime: initTime,
            order: t.PRIORIDAD ?? i,
            className: 'medio'
          })
        }
      }

      let dataSetGroups = new DataSet(groups)
      timeline.setGroups(dataSetGroups)
    },

    setItems(timeline) { // Crea los items de fondo (dia-noche) y los añade a la timeline junto con los items de los medios
      if (this.incendioSelected) {
        // Get lista de items
        let items = this.getItems()

        // Items dia/noche
        let dia = this.$date.now().subtract(this.$date.now().diff(this.incendioSelected.FECHA_CREACION), 'miliseconds')
        let diasTotales = this.$date.now().diff(this.incendioSelected.FECHA_CREACION, 'days') + this.numDiasFuturo + 2
        for (let i = 0; i < diasTotales; i++) {
          let prevSunset = this.$date.parseDate(getSunset(this.incendioSelected.LATITUD, this.incendioSelected.LONGITUD, dia.toDate()))
          dia = dia.add(1, 'days')
          let sunrise = this.$date.parseDate(getSunrise(this.incendioSelected.LATITUD, this.incendioSelected.LONGITUD, dia.toDate()))
          let sunset = this.$date.parseDate(getSunset(this.incendioSelected.LATITUD, this.incendioSelected.LONGITUD, dia.toDate()))

          // Item background noche (antes)
          let item = {
            id: `noche${i}`,
            content: 'Noche',
            start: prevSunset,
            end: sunrise,
            type: 'background',
            className: 'background-noche'
          }
          items.push(item)

          // Item background dia
          item = {
            id: `dia${i}`,
            content: 'Día',
            start: sunrise,
            end: sunset,
            type: 'background',
            className: 'background-dia'
          }
          items.push(item)
        }

        items = PH.convertDatesToUNIX(items)

        let dataSetItems = new DataSet(items)
        timeline.setItems(dataSetItems)

        // Fit timeline
        if (!this.firstTimeFit) { // Solo lo hace la primera vez
          this.firstTimeFit = true
          this.fitTimeline()
        }
      }
    },

    getItems() { // Crear los items de los medios de la timeline
      let items = []

      this.mediosAsignados.forEach(medioAsignado => {
        if (medioAsignado.FECHA_ALARMADO && medioAsignado.FECHA_EN_CAMINO) {
          let item = {
            id: this.$uuid.createUUID(),
            value: medioAsignado.MEDIO,
            group: medioAsignado.ID_MEDIO,
            content: 'Ida',
            start: medioAsignado.FECHA_ALARMADO,
            end: medioAsignado.FECHA_EN_CAMINO,
            className: 'transito',
            title: this.parseFecha(medioAsignado.FECHA_ALARMADO)
          }
          items.push(item)

          if (medioAsignado.FECHA_EN_CAMINO && medioAsignado.FECHA_EN_LUGAR) {
            item = {
              id: this.$uuid.createUUID(),
              value: medioAsignado.MEDIO,
              group: medioAsignado.ID_MEDIO,
              content: 'Incendio',
              start: medioAsignado.FECHA_EN_CAMINO,
              end: medioAsignado.FECHA_EN_LUGAR,
              className: 'incendio',
              title: this.parseFecha(medioAsignado.FECHA_EN_CAMINO)
            }
            items.push(item)

            if (medioAsignado.FECHA_EN_LUGAR && medioAsignado.FECHA_FINALIZADO) {
              item = {
                id: this.$uuid.createUUID(),
                value: medioAsignado.MEDIO,
                group: medioAsignado.ID_MEDIO,
                content: 'Vuelta',
                start: medioAsignado.FECHA_EN_LUGAR,
                end: medioAsignado.FECHA_FINALIZADO,
                className: 'transito',
                title: this.parseFecha(medioAsignado.FECHA_EN_LUGAR)
              }
              items.push(item)

              if (medioAsignado.FECHA_FINALIZADO && medioAsignado.FECHA_FIN_DESCANSO) {
                item = {
                  id: this.$uuid.createUUID(),
                  value: medioAsignado.MEDIO,
                  group: medioAsignado.ID_MEDIO,
                  content: 'Descanso',
                  start: medioAsignado.FECHA_FINALIZADO,
                  end: medioAsignado.FECHA_FIN_DESCANSO,
                  className: 'descanso',
                  title: this.parseFecha(medioAsignado.FECHA_FINALIZADO)
                }
                items.push(item)
              }
            }
          }
        }
      })

      return items
    },

    getNumActuacionesMedio(t) {
      return this.mediosAsignados.filter(x => x.ID_MEDIO === t.ID_MEDIO).length
    },

    fitTimeline() {
      if (this.mediosAsignados.length > 0) {
        this.timeline.fit()
      }
    },

    /* Filtros */
    parseFecha(fecha) {
      return fecha ? this.$date.parseDate(fecha).format('DD-MM-YYYY HH:mm') : this.$date.parseDate(this.$date.now()).format('YYYY-MM-DD HH:mm')
    },

    horaFin(t, estado) {
      if (t.FECHA_EN_CAMINO && estado === 0) {
        return t.FECHA_EN_CAMINO
      }

      if (t.FECHA_EN_LUGAR && estado <= 1) {
        return t.FECHA_EN_LUGAR
      }

      if (t.FECHA_FINALIZADO && estado <= 2) {
        return t.FECHA_FINALIZADO
      }

      if (t.FECHA_FIN_DESCANSO && estado <= 3) {
        return t.FECHA_FIN_DESCANSO
      }

      return this.$date.now()
    },

    horaAlarmado(t) {
      if (t.FECHA_EN_CAMINO) {
        return t.FECHA_EN_CAMINO
      }
      if (t.FECHA_EN_LUGAR) {
        return t.FECHA_EN_LUGAR
      }

      return t.FECHA_FINALIZADO ? t.FECHA_FINALIZADO : this.$date.now()
    },

    horaEnCamino(t) {
      if (t.FECHA_EN_LUGAR) {
        return t.FECHA_EN_LUGAR
      }

      return t.FECHA_FINALIZADO ? t.FECHA_FINALIZADO : this.$date.now()
    },

    horaFinalizado(t) {
      return t.FECHA_FINALIZADO ? t.FECHA_FINALIZADO : this.$date.now()
    },

    fechahora(value) {
      const date = this.$date.parseDate(value)
      return date.isValid() ? this.$date.formatDate(date, 'DD/MM/YYYY HH:mm') : '-'
    },

    hhmm(value) {
      const hour = this.$date.parseDate(value)
      return hour.isValid() ? this.$date.formatDate(hour, 'HH:mm') : '-'
    },
    horasmin(value) {
      return value ? `${Math.floor(value / 60)}h ${value % 60}min` : null
    },
    min(value) {
      let min = null
      if (value) {
        const hhmm = value.split(':')
        min = hhmm[0] * 60 + parseInt(hhmm[1])
      }
      return min
    }
  }
}
</script>

<style scoped>
@import '../../../node_modules/vis-timeline/dist/vis-timeline-graph2d.min.css';
/*TODO: Nose si hace algo*/

/* Colores TODO: repetido en MMTTT */
::v-deep .vis-item.transito {
  background-color: #FFC400;
}

::v-deep .vis-item.incendio {
  background-color: #FF0000;
}

::v-deep .vis-item.descanso {
  background-color: #FFFF00;
}

::v-deep .vis-item.demora {
  background-color: #00AABB;
}

::v-deep .vis-item.background-dia {
  background-color: rgba(170, 255, 248, 0.541);
}

::v-deep .vis-item.background-noche {
  background-color: rgba(235, 170, 255, 0.329);
}

::v-deep .vis-item.inicioJornadaLinea {
  background-color: #43d400;
  border-right: solid 3px #43d400;
}

::v-deep .vis-timeline,
.vis-bottom {
  background: white;
}

::v-deep .vis-item.transito-plan {
  background-color: rgba(255, 196, 0, 0.466);
}

::v-deep .vis-item.incendio-plan {
  background-color: rgba(255, 0, 0, 0.479);
}

::v-deep .vis-item.descanso-plan {
  background-color: rgba(255, 255, 0, 0.479);
}

::v-deep .vis-item.demora-plan {
  background-color: rgba(0, 171, 187, 0.521);
}

.legend {
  background-color: rgba(0, 0, 0, 0.03);
  padding: 8px;
  border-radius: 4px;
}
</style>
